import StarIcon from '@mui/icons-material/Star';
import { Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

import CapterraIcon from './CapterraIcon.svg';

const StarRating: FC = () => {
  const { spacing } = useTheme();
  return (
    <Stack direction="row" gap={spacing(0.25)} justifyContent="center" alignItems="center">
      <StarIcon color="secondary" sx={{ fontSize: spacing(2) }} />
      <StarIcon color="secondary" sx={{ fontSize: spacing(2) }} />
      <StarIcon color="secondary" sx={{ fontSize: spacing(2) }} />
      <StarIcon color="secondary" sx={{ fontSize: spacing(2) }} />
      <StarIcon color="secondary" sx={{ fontSize: spacing(2) }} />
    </Stack>
  );
};

type TestimonialHeadingProps = {
  header: string;
};

const TestimonialHeading: FC<TestimonialHeadingProps> = ({ header }: TestimonialHeadingProps) => {
  const { spacing } = useTheme();
  return (
    <Stack gap={spacing(2)} justifyContent="center" alignItems="center">
      <Typography variant="h5-bold" align="center">
        {header}
      </Typography>
      <Stack
        direction="row"
        gap={spacing(1)}
        justifyContent="center"
        alignItems="center"
        px={spacing(1)}
        py={spacing(0.25)}
        sx={{ backgroundColor: '#E5F9FF', borderRadius: spacing(12.5) }}
      >
        <img alt="Capterra Icon" src={CapterraIcon} />
        <StarRating />
        <Typography variant="body2">4.9 rating</Typography>
      </Stack>
    </Stack>
  );
};

export { TestimonialHeading };
